import screenfull from 'screenfull';

(function ($) {
    $(document).ready(function () {

        $('.flash-container').each(function () {

            if ( $(this).hasClass('swf') ) {

                let initWidth = $('embed', this).width();
                let initHeight = $('embed', this).height();

                $(this).data('initwidth', initWidth).attr('data-initwidth', initWidth).data('initheight', initHeight).attr('data-initheight', initHeight);
                recalcGame();

            }

            if ( $(this).hasClass('iframe') ) {

                let initWidth = $('iframe', this).width();
                let initHeight = $('iframe', this).height();

                $(this).data('initwidth', initWidth).attr('data-initwidth', initWidth).data('initheight', initHeight).attr('data-initheight', initHeight);
                recalcGame();

            }
        });

        $('.search-form-send--js').on('click', function(e) {
            e.preventDefault();
            $('.search-form--js').submit();
        });

        const el = document.getElementById('flash-container');

        $('.btn-fullscreen--js').on('click', function(e) {
            e.preventDefault();

            if (screenfull.isEnabled) {
                screenfull.request(el);
            }
        });

        if(screenfull.isEnabled) {
            screenfull.on('change', () => {
                $('#flash-container').toggleClass('fullscreen');
            });
        }

        $('.bookmark--js').on('click', function (e) {
            e.preventDefault();
            addFavorite(this);
        });

      /**
       * Back to top btn
       */
      if ($('#back-to-top').length) {
        var scrollTrigger = 100, // px
          backToTop = function () {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > scrollTrigger) {
              $('#back-to-top').addClass('show');
            } else {
              $('#back-to-top').removeClass('show');
            }
          };
        backToTop();
        $(window).on('scroll', function () {
          backToTop();
        });
        $('#back-to-top').on('click', function (e) {
          e.preventDefault();
          $('html,body').animate({
            scrollTop: 0
          }, 700);
        });
      }

    });

    $(window).resize(function(){
        
    });

    $(window).on('load', function(){
    });

    /**
     * Recalc Game
     */
    function recalcGame() {
        let fullwidth = $('.flash-container').data('fullwidth');

        if ( !fullwidth ) {

            $('.flash-container.swf').each(function () {
                recalcSWF();
            });
            $('.flash-container.iframe').each(function () {
                recalcIframe();
            });

        } else {

            var gameWidth = $('.flash-container').data('initwidth');

            var sidebarWidth = 0;
            if ($(window).width()>992 ) {
                sidebarWidth = $('.layout__sidebar').innerWidth();
            }

            $('.flash-container.swf').each(function () {
                gameWidth = $('.flashobj', this).width();

            });
            $('.flash-container.iframe').each(function () {
                gameWidth = $('iframe', this).width();
            });

            var fullWidthContainer = sidebarWidth + gameWidth + 30 + 20 + 20; // include paddings
            $('.js-container-game').css('min-width', fullWidthContainer + 'px');

            // Добавим паддинг от wrapper
            var fullWidthWrapper = fullWidthContainer; // include paddings wrapper
            $('body, html').css('min-width', fullWidthWrapper + 'px');

        }

    }

    function recalcSWF() {

        var layout = $('.flash-container');
        var gameObj = $('.flashobj');
        var game = $('.flashobj embed');

        var wWidth = window.innerWidth;
        var wHeight = window.innerHeight;

        var initWidth = layout.data('initwidth');
        var initHeight = layout.data('initheight');

        var newWidth, newHeight, ratio = 0;

        gameObj.hide();
        game.hide();

        newWidth = layout.innerWidth();

        ratio = parseInt(initWidth) / parseInt(initHeight);
        newHeight = newWidth / ratio;

        // if result height object > height window
        if (newHeight > wHeight) {
            newHeight = wHeight;
            newWidth = newHeight * ratio;
        }

        if ( newHeight > 730 && !layout.hasClass('fullscreen') ) {
            newHeight = 730;
            newWidth = newHeight * ratio;
        }

        gameObj.attr('width', newWidth);
        gameObj.attr('height', newHeight);

        game.attr('width', newWidth);
        game.attr('height', newHeight);

        gameObj.show();
        game.show();


    }

    function recalcIframe() {

        var layout = $('.flash-container');
        var game = $('.flash-container iframe');

        var wWidth = window.innerWidth;
        var wHeight = window.innerHeight;

        var initWidth = layout.data('initwidth');
        var initHeight = layout.data('initheight');

        var newWidth, newHeight, ratio = 0;



        game.hide();

        newWidth = layout.innerWidth();

        ratio = parseInt(initWidth) / parseInt(initHeight);
        newHeight = newWidth / ratio;

        // if result height object > height window
        if (newHeight > wHeight) {
            newHeight = wHeight;
            newWidth = newHeight * ratio;
        }

        if ( newHeight > 730 && !layout.hasClass('fullscreen') ) {
            newHeight = 730;
            newWidth = newHeight * ratio;
        }

        game.attr('width', newWidth);
        game.attr('height', newHeight);

        game.show();

    }


    /*
     * Add Favorites
     */
    function addFavorite(a) {
        var title = document.title;
        var url = document.location;
        try {
            // Internet Explorer
            window.external.AddFavorite(url, title);
        }
        catch (e) {
            try {
                // Mozilla
                window.sidebar.addPanel(title, url, "");
            }
            catch (e) {
                // Opera
                if (typeof(opera) == "object" || window.sidebar) {
                    a.rel = "sidebar";
                    a.title = title;
                    a.url = url;
                    a.href = url;
                    return true;
                }
                else {
                    // Unknown
                    alert('Нажмите Ctrl-D чтобы добавить страницу в закладки');
                }
            }
        }
        return false;
    }

})(jQuery);
